import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {ERASER_BRUSH} from '@PosterWhiteboard/models/draw.class';
import {useAppSelector} from '@/hooks';

interface DrawColorOptionProps {
  onClickColorFill(): void;
}

export function DrawColorOption({...props}: DrawColorOptionProps): ReactElement | null {
  const color = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.drawBrush?.strokeColor;
  });
  const drawBrush = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.drawBrush;
  });
  const isImageGeneratingFromDrawing = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isImageBeingGenerated;
  });

  if (drawBrush?.brush === ERASER_BRUSH) {
    return null;
  }

  if (!color) {
    throw new Error('color does not exist in draw option');
  }

  const getData = (): ColorFillStorage[] => {
    return [
      {
        id: 'draw-color-option',
        color: [
          {
            id: 'primary',
            color: color,
          },
        ],
        fillType: ColorFillPropertyType.SOLID,
      },
    ];
  };

  const onClickHandler = (): void => {
    props.onClickColorFill();
  };

  return (
    <ContextualMenuColorFillOption
      id="draw-color-option"
      label={window.i18next.t('pmwjs_color')}
      isDisabled={isImageGeneratingFromDrawing}
      data={getData()}
      onClick={onClickHandler}
    />
  );
}
